import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { userRoles } from "@/constants/UserRoles";
import { ModelList } from "@/modules/model-list";

const UserRolesList = ({ roles }) => {
  const { t } = useTranslation();

  // sort roles by priority and translate them
  const translatedSortedRoles = (roles ?? [])
    .map((role) => {
      const key = role.subject_id
        ? role.name.substr(0, role.name.lastIndexOf("."))
        : role.name;
      return {
        name: t(`role:${key.replace(".", "")}`),
        key,
      };
    })
    .sort(
      (a, b) =>
        userRoles.find((role) => role.name === a.key).priority -
        userRoles.find((role) => role.name === b.key).priority
    )
    .filter((role, pos, allRoles) => {
      return !pos || role.key !== allRoles[pos - 1].key;
    });

  return <ModelList model="role" items={translatedSortedRoles} />;
};

UserRolesList.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
};

export default UserRolesList;
